<template>
  <e-modal
    :visible="visible"
    :title="title"
    :width="600"
    :loading="loading"
    @close="onClose"
    @ok="onSubmit((e) => onSubmitFun(e))"
  >
    <a-spin tip="Loading..." :spinning="loading">
      <a-form>

        <e-show title="商品信息" style="margin-bottom: 20px;">
          <div class="goods">
          <div class="goods-img">
            <img :src="goods.pic" alt="" />
          </div>
          <div class="goods-info">
            <div class="goods-title">
              <div class="title">{{ goods.title }}</div>
              <div class="goods-price">¥{{ goods.promotionPrice }}</div>
            </div>
            <div class="goods-text">
              ¥{{ goods.promotionPrice }}/{{ goods.unit }}
            </div>
          </div>
        </div>
        </e-show>
        <e-input
          title="用户姓名"
          :validate="validateInfos.customerName"
          v-model:value="modelRef.customerName"
        />

        <e-input
          title="联系电话"
          :validate="validateInfos.customerMobile"
          v-model:value="modelRef.customerMobile"
        />

        <e-input
          title="详细地址"
          :validate="validateInfos.address"
          v-model:value="modelRef.address"
        />

        <e-choose-images :valueCol="20" title="现场照片" v-model:value="userPics" />
      </a-form>
    </a-spin>
  </e-modal>
</template>

<script>
import { defineComponent, ref, reactive, toRaw } from 'vue'
import { Form } from 'ant-design-vue'
import form from '@/mixins/form'
import { OrderClass } from '@/apis/goods'

const useForm = Form.useForm
const api = new OrderClass()
export default defineComponent({
  components: {},
  mixins: [form],
  emits: ['ok'],
  setup (props, { emit }) {
    const loading = ref(false)
    const visible = ref(false)
    const isEdit = ref(false)
    const title = ref('')

    const modelRef = reactive(api.modelRef)
    const rulesRef = reactive(api.rulesRef)

    const { resetFields, validate, validateInfos } = useForm(
      modelRef,
      rulesRef
    )

    const onClose = () => {
      resetFields()
      loading.value = false
      visible.value = false
    }

    const goods = ref({})
    const userPics = ref([])

    return {
      title,
      visible,
      loading,
      isEdit,
      modelRef,
      validateInfos,
      goods,
      userPics,
      resetFields,
      validate,
      onClose
    }
  },

  methods: {
    open (goods) {
      this.goods = goods

      this.modelRef.goodsId = goods.id
      this.visible = true
    },

    onSubmitFun (e) {
      const data = toRaw(e)

      data.userPics = this.userPics.join(',')
      data.userId = this.$store.state.user.userInfo.id
      data.isManage = true

      api.create(data).then(() => {
        this.loading = false
        this.$message.success('添加成功')
        this.$emit('ok')
        this.onClose()
      })
    }
  }
})
</script>

<style lang="less" scoped>
.goods {
  display: flex;
  border: 1px solid #333;
  border-radius: 10px;
  padding: 10px;

  .goods-img {
    width: 70px;
    height: 70px;
    overflow: hidden;
    border-radius: 10px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .goods-info {
    padding-left: 10px;
    flex: 1;

    .goods-title {
      display: flex;
      font-size: 16px;
      line-height: 30px;
      padding-bottom: 10px;

      .title {
        flex: 1;
      }

      .goods-price {
        width: 100px;
        text-align: right;
        font-weight: bold;
      }
    }

    .goods-text {
      font-size: 14px;
      line-height: 28px;
      color: #999;
    }
  }
}
</style>
